import { Box } from "@mui/material"
import OtherSetting from "../../OtherSetting"
import type { otherSetting } from "../../types/other-setting"

function BottomBar({
  rightSidebarOpen,
  currentOtherSetting,
  onOtherSettingChange,
  canSelectOoame,
  canSelectOohidery,
  canSelectRankiryuu,
}: {
  rightSidebarOpen: boolean;
  currentOtherSetting: otherSetting;
  onOtherSettingChange: (setting: otherSetting) => void;
  canSelectOoame: boolean;
  canSelectOohidery: boolean;
  canSelectRankiryuu: boolean;
}) {
  return (
    <Box sx={{
      height: rightSidebarOpen ? 80 : 0,
      backgroundColor: '#fafafa',
      borderTop: rightSidebarOpen ? '1px solid #e0e0e0' : 'none',
      overflow: 'hidden',
      transition: 'height 0.1s ease-in-out',
      position: 'absolute',
      bottom: 0,
      left: { xs: 0, md: '400px' },
      right: 0,
      zIndex: 1000
    }}>
      {rightSidebarOpen && (
        <Box sx={{ px: 1.5, height: '80px', display: 'flex', alignItems: 'center' }}>
          <OtherSetting
            otherSetting={currentOtherSetting}
            handleSaveOtherSetting={onOtherSettingChange}
            canSelectOoame={canSelectOoame}
            canSelectOohidery={canSelectOohidery}
            canSelectRankiryuu={canSelectRankiryuu}
          />
        </Box>
      )}
    </Box>

  )
}
export default BottomBar;
